/**
 * React entry point for the Alterspective Instruct task pane.
 *
 * Initialises Office.js, then mounts the root App component
 * wrapped in the AuthProvider for authentication state.
 */
import { createRoot } from 'react-dom/client';
import { initializeOffice } from '../office-init';
import { AuthProvider } from '../auth/auth-context';
import { App } from './App';

const container = document.getElementById('container');
if (!container) {
  throw new Error('Root #container element not found in taskpane.html');
}

const root = createRoot(container);

initializeOffice()
  .then(() => {
    root.render(
      <AuthProvider>
        <App />
      </AuthProvider>
    );
  })
  .catch((err: unknown) => {
    const message = err instanceof Error ? err.message : 'Unknown initialization error';
    console.error('Office initialization failed:', message);
    root.render(
      <div style={{ padding: 16, color: '#d13438', fontFamily: 'Segoe UI, sans-serif' }}>
        <h2>Initialization Error</h2>
        <p>{message}</p>
        <p>Please ensure the add-in is opened within Microsoft Word.</p>
      </div>
    );
  });
